import { useEffect, useRef, useState, useCallback } from "react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

function wsUrl() {
  const base = BACKEND_URL.replace(/^http/, "ws");
  return `${base}/api/ws/stream`;
}

// Streams live activity events over WebSocket with auto-reconnect.
export function useStream(max = 30) {
  const [events, setEvents] = useState([]);
  const [connected, setConnected] = useState(false);
  const wsRef = useRef(null);
  const retryRef = useRef(null);

  const connect = useCallback(() => {
    let ws;
    try {
      ws = new WebSocket(wsUrl());
    } catch (e) {
      retryRef.current = setTimeout(connect, 4000);
      return;
    }
    wsRef.current = ws;
    ws.onopen = () => setConnected(true);
    ws.onmessage = (msg) => {
      try {
        const ev = JSON.parse(msg.data);
        setEvents((prev) => [ev, ...prev].slice(0, max));
      } catch (_) {}
    };
    ws.onclose = () => {
      setConnected(false);
      retryRef.current = setTimeout(connect, 4000);
    };
    ws.onerror = () => {
      try { ws.close(); } catch (_) {}
    };
  }, [max]);

  useEffect(() => {
    connect();
    return () => {
      clearTimeout(retryRef.current);
      if (wsRef.current) {
        wsRef.current.onclose = null;
        try { wsRef.current.close(); } catch (_) {}
      }
    };
  }, [connect]);

  return { events, connected };
}
